import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Platforms.css';

const MT5: React.FC = () => {

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    }
  };

  return (
    <motion.div 
      className="platforms-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      transition={{ staggerChildren: 0.2 }}
    >
      <div className="container">
        <motion.div className="page-title" variants={itemVariants}>
          <h1>MetaTrader 5 (MT5)</h1>
          <p>Advanced multi-asset trading platform with sophisticated analysis tools</p>
        </motion.div>
        
        <motion.div className="platform-intro" variants={itemVariants}>
          <p>MetaTrader 5 is the next-generation platform for online trading on forex and exchange markets. It is designed for professional traders who demand advanced analytical tools and more order types for effective trading.</p>

        </motion.div>
        
        <motion.div className="platform-features" variants={containerVariants}>
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Advanced Charting</h3>
            <p>21 timeframes, 39 technical indicators, and 24 analytical objects for comprehensive market analysis</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Economic Calendar</h3>
            <p>Integrated economic calendar with impact indicators and time filters</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Automated Trading</h3>
            <p>Strategy Tester with 8 different testing modes to optimize your trading strategies</p>
          </motion.div>
        </motion.div>
        
        <motion.div className="platform-actions" variants={itemVariants}>
          <h2>Get Started with MT5</h2>
          <p>Choose the broker that best suits your trading style and requirements</p>
          <div className="btn-container">
            <Link to="/ib-partners" className="btn">View Recommended Brokers</Link>
            <Link to="/education" className="btn secondary">Learn More</Link>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default MT5;